// @flow

import { combineReducers } from 'redux-immutable';
import Home from 'app/containers/Home/redux';
import Bookmarks from 'app/containers/Bookmarks/redux';
import Preview from 'app/containers/Preview/redux';
import Search from 'app/containers/Search/redux';
import Login from 'app/containers/Login/redux';
import DirectLogin from 'app/containers/DirectLogin/redux';
import Profile from 'app/containers/Profile/redux';
import Play from 'app/containers/Play/redux';
import Details from 'app/containers/Details/redux';
import Grid from 'app/containers/Grid/redux';
import LiveTv from 'app/containers/LiveTv/redux';
import LiveAparat from 'app/containers/LiveAparat/redux';
import Payment from 'app/containers/Payment/redux';

const createRootReducer = () => combineReducers({
  Home,
  Bookmarks,
  Search,
  Login,
  DirectLogin,
  Profile,
  Preview,
  Play,
  Details,
  Grid,
  LiveTv,
  LiveAparat,
  Payment,
});

export default createRootReducer;
